import { createElement } from 'react';
import {
  discoveryApiRef,
  fetchApiRef,
  ApiBlueprint,
  createFrontendPlugin,
  SubPageBlueprint,
} from '@backstage/frontend-plugin-api';
import { asyncTasksApiRef } from '@internal/backstage-plugin-devops-async-tasks-react';
import { AsyncTasksApiClient } from './api/AsyncTasksApiClient';

const devopsAsyncTasksApi = ApiBlueprint.make({
  name: 'devopsAsyncTasksApi',
  params: defineParams =>
    defineParams({
      api: asyncTasksApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AsyncTasksApiClient({ discoveryApi, fetchApi }),
    }),
});

export const asyncTasksSystemPage = SubPageBlueprint.make({
  attachTo: { id: 'page:devtools', input: 'pages' },
  params: {
    path: 'async-tasks-system',
    title: 'Async Tasks',
    loader: () =>
      import('./components/AsyncTasks').then(m =>
        createElement(m.AsyncTasksSystemPage),
      ),
  },
});

export const devopsAsyncTasksPlugin = createFrontendPlugin({
  pluginId: 'devops-async-tasks',
  extensions: [devopsAsyncTasksApi, asyncTasksSystemPage],
});
